import request from "@/network/request"

// 微信公众号发票保存
export function saveInvoice(data) {
	return request({
		url: "/sclm/apply/app/scan/createInvoice",
		method: 'post',
		data
	});
}
